<template>
  <div>
    <div v-if="!result.hasOwnProperty('error')">
      <div class="row">
        <div class="col-lg-5 col-md-5 pr-5">
          <h5 class="mb-3">{{result.title}}</h5>
          <div>
            <img :src=result.thumbnail  style="max-width: 400px; max-height: 300px" alt="" class="mb-2" />
          </div>
          <p class="small">Duration: {{GetDisplayTimeString(result.duration)}}</p>
        </div>

        <div class="col-lg-7 col-md-5 pl-5">
          <ul id="pills-tab" role="tablist" class="nav nav-tabs mb-0 h5">
            <li v-if="result.result.videos" class="nav-item"><a id="pills-1-tab" data-toggle="pill" href="#pills-1" role="tab" aria-controls="pills-1" aria-selected="true" class="nav-link px-lg-5 px-4 active">Video</a></li>
            <li v-if="result.result.audios" class="nav-item"><a id="pills-2-tab" data-toggle="pill" href="#pills-2" role="tab" aria-controls="pills-2" aria-selected="false" class="nav-link px-lg-5 px-4">Audio</a></li>
          </ul>
          <div id="pills-tabContent" class="tab-content bg-light border border-top-0 py-4 text-nowrap">
            <div id="pills-1" role="tabpanel" aria-labelledby="pills-1-tab" class="tab-pane fade show active">
              <div class="table-responsive">
                <table class="table table-borderless">
                  <thead class="h6">
                    <tr>
                      <th>Quality</th>
                      <th>Format</th>
                      <th>Size</th>
                      <th></th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody class="small">
                    <tr v-for="(video,index) in result.result.videos" :class="{collapse:index>3}"  id="collapseExample1">
                      <td>{{video.note}}</td>
                      <td>{{video.ext}}</td>
                      <td>{{renderSize(video.fileSize)}}</td>
                      <td></td>
                      <td>
                        <a  v-bind:href="video.url" target="_blank" v-show="!videoShowLimit(video.note)" class="btn btn-sm btn-primary" style="min-width: 110px;">Get HD Video</a>
                        <a href="javascript:;" v-show="videoShowLimit(video.note)" @click="showLimit(0,video.note)" class="btn btn-sm btn-primary" style="min-width: 110px;" ref="videoLink">Get HD Video</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  <a data-toggle="collapse" href=".collapse" role="button" aria-expanded="false">
                    <span>Show More <i  class="kv kv-angle-down" style="vertical-align: -1px;"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div id="pills-2" role="tabpanel" aria-labelledby="pills-2-tab" class="tab-pane fade">
              <div class="table-responsive w-100">
                <table class="table table-borderless">
                  <thead class="h6">
                  <tr>
                    <th>Quality</th>
                    <th>Format</th>
                    <th>Size</th>
                    <th>Download</th>
                  </tr>
                  </thead>
                  <tbody class="small">
                    <tr v-for="audio in result.result.audios" class="collapse1" id="collapseExample1">
                        <td>{{audio.note}}</td>
                        <td>{{audio.ext}}</td>
                        <td>{{renderSize(audio.fileSize)}}</td>
                        <td>
                          <a v-bind:href="audio.url" target="_blank" v-show="!audioShowLimit(audio.note)" class="btn btn-sm btn-primary" style="min-width: 110px;">Get Audio</a>
                          <a href="javascript:;" v-show="audioShowLimit(audio.note)" v-bind:download="audio.url" @click="showLimit(1,audio.note)" class="btn btn-sm btn-primary" style="min-width: 110px;">Get Audio</a>
                        </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialogs :infos="dialogs_infos"/>
  </div>
</template>

<script>
import dialogs from './dialogs'
export default {
  name: 'snifferResult',
  props: ['result'],
  components: {'dialogs': dialogs},
  data () {
    return {
      dialogs_infos: []
    }
  },
  mounted: function(){
    if (this.result.hasOwnProperty('error')){
      let error = this.result.error;
      if (error === 'network error'){
        this.dialogs_infos.push('Sorry, please check your network!');
      } else {
        this.dialogs_infos.push('The link can\'t be analyzed, or it\'s prohibited to download.');
        this.dialogs_infos.push('But don’t worry, we have another powerful solution for you');
      }
      $('#Modal-product-popup1').on('hide.bs.modal', ()=>this.$emit('closeErrorDialogEvent'));
      $('#Modal-product-popup1').modal();
    }
  },
  methods:{
    showLimit: function(limitType, Qulity){
      if (limitType === 0){
        if(Qulity && Qulity.indexOf("p")!= -1 &&  Qulity.slice(0,Qulity.length-1) > 480) {
          this.dialogs_infos.push('Download 1080P & 4K Videos without Quality Loss');
          $('#Modal-product-popup1').modal()
        }
      } else if (limitType === 1) {
        if (Qulity && Qulity.indexOf("kbps") != -1 && Qulity.slice(0, Qulity.length-4)) {
          this.dialogs_infos.push('Download 320kbps High-Quality Audio with One Click');
          $('#Modal-product-popup1').modal()
        }
      }
    },
    videoShowLimit(Qulity){
      return Qulity && Qulity.indexOf("p")!= -1 &&  Qulity.slice(0,Qulity.length-1) > 480;
    },

    audioShowLimit(Qulity){
      return Qulity && Qulity.indexOf("kbps") != -1 && Qulity.slice(0, Qulity.length-4) > 120;
    },
    renderSize(value) {
      if (null == value || value == '') {
        return "0 Bytes";
      }
      let unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
      let index = 0;
      let srcSize = parseFloat(value);
      index = Math.floor(Math.log(srcSize) / Math.log(1024));
      let size = srcSize / Math.pow(1024, index);
      size = size.toFixed(2);//保留的小数位数
      return size + unitArr[index];
    },

    GetDisplayTimeString(times) {
      let result = '00:00:00';
      let hour, minute, second
      if (times > 0) {
        hour = Math.floor(times / 3600);
        let showH = hour > 0;
        if (hour < 10) {
          hour = "0" + hour;
        }
        minute = Math.floor((times - 3600 * hour) / 60);
        if (minute < 10) {
          minute = "0" + minute;
        }
        second = Math.floor((times - 3600 * hour - 60 * minute) % 60);
        if (second < 10) {
          second = "0" + second;
        }
        if (showH)
          result = hour + ':' + minute + ':' + second
        else
          result = minute + ':' + second;
      }
      return result;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/snifferResult.vue